import React from "react";

const RangeSlider = ({ value = 15, onChange, min = 0, max = 50 }) => {
  const getBackgroundSize = () => {
    const percent = ((value - min) / (max - min)) * 100;
    return `linear-gradient(to right, #0f172a 0%, #0f172a ${percent}%, #e2e8f0 ${percent}%, #e2e8f0 100%)`;
  };

  const handleChange = (e) => {
    const newValue = Number(e.target.value);
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div className="range-wrapper">
      <div className="range-header">
        <span>Range (miles)</span>
        <span>{value} miles</span>
      </div>

      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={handleChange}
        style={{ background: getBackgroundSize() }}
        className="range-slider"
      />

      <div className="range-note">
        Radius around your base location where jobs will be shown
      </div>
    </div>
  );
};

export default RangeSlider;
